import { render, staticRenderFns } from "./LayoutCheckout.vue?vue&type=template&id=2d5d08f0&scoped=true"
import script from "./LayoutCheckout.vue?vue&type=script&lang=js"
export * from "./LayoutCheckout.vue?vue&type=script&lang=js"
import style0 from "./LayoutCheckout.vue?vue&type=style&index=0&id=2d5d08f0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5d08f0",
  null
  
)

export default component.exports